import QueryParams from "sites/utils/QueryParams";

// we redirect to site with this query param from affiliate dashboard, to bypass AV for affiliate user
const AGE_VERIFICATION_BYPASS_QUERY_PARAM = 'bpav'; // bypassageverification

export default () => {
   const bypassToken = QueryParams.getParam(AGE_VERIFICATION_BYPASS_QUERY_PARAM)
   if(Boolean(bypassToken)) {
      localStorage.setItem('IS_AGE_VERIFIED_BY_ID', true)
      QueryParams.removeQueryParam(AGE_VERIFICATION_BYPASS_QUERY_PARAM)
   }
}
